/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { LeftArrow, RightArrow } from './arrows';
import { Navigate } from 'react-router-dom';
import * as S from './styles';

export interface INavItem {
  type: string;
  title?: string;
  key: string;
  link: string;
}

export interface INavItemsProps {
  navItems?: INavItem[] | any;
  activeKey: string;
  onNavItemClick?(key: string): void;
  onSearchSubmit?(key: string): void;
  isLargeTitle?: boolean;
  fontScale?: number;
}

function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev();
  }
}

export const NavItems = (props: INavItemsProps) => {
  const {
    navItems,
    carouselStyles,
    onNavItemClick,
    onSearchSubmit,
    isLargeTitle,
    activeKey,
    fontScale,
  } = props;
  const [searchText, setSearchText] = useState<string>('');
  const [keyActive, setKeyActive] = useState<string>(activeKey);
  console.log('fonto->', fontScale);
  useEffect(() => {
    setKeyActive(activeKey);
  }, [activeKey]);
  // useEffect(() => {
  //   window.history.replaceState(null, null, activeKey);
  // }, []);
  // const [showInput, setShowInput] = useState<boolean>(false);

  // const handleSearchClick = () => {
  //   if (!showInput) {
  //     setShowInput(!showInput);
  //   }
  //   if (showInput) {
  //     setShowInput(!showInput);
  //   }
  // };

  const onNavClick = (item: any) => {
    console.log(`item on nav click`, item);
    setKeyActive(item?.key);
    onNavItemClick && onNavItemClick(item?.key);
    // window.history.replaceState(null, null, item?.link);
  };

  // const onSearchInputChange = (event: any) => {
  //   console.log('search text', event?.target?.value);
  //   setSearchText(event?.target?.value);
  // };

  // document.addEventListener('keydown', function (event) {
  //   if (event.code === 'Enter') {
  //     onSearchSubmit && onSearchSubmit(searchText);
  //   }
  // });

  const _renderType = (
    item: ICarouselItem,
    index: number,
    isActive: boolean
  ) => {
    console.log('item', item);
    let _comp: any = [];
    _comp.push(
      <S.NavLink key={`${item?.key}-${index}`}>
        <S.Anchor
          isLargeTitle={isLargeTitle}
          active={isActive}
          fontScale={fontScale}
          className="nav-link"
        >
          {item?.title}
        </S.Anchor>
      </S.NavLink>
    );
    return _comp;
  };

  return (
    <S.ScrollContainer>
      <ScrollMenu
        LeftArrow={LeftArrow}
        RightArrow={RightArrow}
        onWheel={onWheel}
      >
        {navItems?.map((item, index) => (
          <S.CarouselItemContainer
            key={`carousel-item-${index}`}
            active={item?.key === keyActive}
            onClick={() => onNavClick(item)}
            id={item?.key}
          >
            {_renderType(item, index, item?.key === keyActive)}
          </S.CarouselItemContainer>
        ))}
      </ScrollMenu>
    </S.ScrollContainer>
  );
};

NavItems.defaultProps = {};
